import React, { useState } from 'react';

export default function FetchButton(props: {
    fetch?: () => Promise<void>,
    className?: string,
    children?: JSX.Element[] | JSX.Element | string
}) {
    const [isLoad, setIsLoad] = useState(false)
    return (
        <button
            className={props.className}
            onClick={async () => {
                try {
                    setIsLoad(true);
                    if (props.fetch)
                        await props.fetch();
                    setIsLoad(false);
                } catch (e) {
                    console.error(e);
                }
            }}
            disabled={isLoad}
        >
            {isLoad ?
                <div className="spinner-border text-primary" role="status">
                    <span className="sr-only">Loading...</span>
                </div> : props.children}
        </button>
    )
}